/**
 * 【KYMW1404】売り場取得用VO
 *
 * @export SellingAreaListModel
 * @class SellingAreaListModel
 */
export class SellingAreaListModel {
  /**
   * 画面ID
   */
  public formID = String('KYMW1404');

  /**
   * 媒体区分
   */
  public mediumType = String('');
}
